module.exports = __webpack_public_path__ + "static/img/vpn-disconnected.f2e88cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vpn-disconnected.png
// module id = yc/j
// module chunks = 11